import _ from 'lodash';
import React__default from 'react';
import { RadioGroup as RadioGroup$1, Label, Radio, FieldError } from 'react-aria-components';
import { WarningIcon } from '../icons/WarningIcon.js';
import './RadioGroup.scss';

const RadioGroup = (props) => {
    const { hasError, ...radioGroupProps } = props;
    return (React__default.createElement(RadioGroup$1, { ..._.omit(radioGroupProps, 'options', 'label'), "data-rev-component": 'radio-group', className: props.className, isInvalid: !!hasError },
        props.label ? React__default.createElement(Label, { className: 'radio-group-label--rev' }, props.label) : null,
        props.items?.map((option, i) => (React__default.createElement(Radio, { className: 'radio-group-option--rev', key: i, value: option.value, isDisabled: option.isDisabled, ...option.itemProps },
            React__default.createElement("span", { className: 'radio-group-option-label--rev' }, option.label ?? _.startCase(option.value.toLowerCase()))))),
        hasError && typeof hasError === 'string' && (React__default.createElement(FieldError, { className: 'radio-group-error--rev' },
            React__default.createElement(WarningIcon, null),
            hasError))));
};

export { RadioGroup };
//# sourceMappingURL=RadioGroup.js.map
